/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXPORT : MENU : FILTER : STYLES --------------- ++++++++++ */
export default {
  filtermenu: {
    position: 'relative', // needed so the menu is relative to this indicator only
    height: pxToEm(56),
    maxWidth: '13em',
    '& .name-filters':{
      background: 'white !important',
      '&.menuOpen-true': {
        borderColor: 'rgb(20, 148, 244)'
      }
    },
    '& .menuitems': {
      transition: 'all .05s ease-out 0s'
    },

    // ----- states ----- //
    '&.active-true': {
      '& .menuitems': {
        opacity: '1',
        transform: 'translateX(0%) scale(1)',
        zIndex: '2'
      }
    },
    '&.active-false': {
      '& .menuitems': {
        opacity: '0',
        transform: 'translateX(0%) scale(0)',
        zIndex: '-1'
      }
    },
    '& .dropdownindicator': {
      background: 'none',
      border: 'none',
      justifyContent: 'flex-start',
      marginTop: '-3px',
      width: '100%',

      '& .name-iconTitle': {
        width: '100%',
      },

      '& .title': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '& .icon': {
        paddingRight: 0
      },
      '& .icon.name-undefined': {
        display: 'none',
      },
      '& .name-nameTitle': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '& .name': {
          color: themeV2.color.primary.main,
          fontSize: '18px',
          fontWeight: '400',
          height: '1.5em',
          alignItems: 'center',
          paddingTop: pxToEm(6),
          width: '100%',
          textOverflow: 'ellipsis',
          display: 'block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }
      },
    }
  }
};
